import script from "./SuccessMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessMessage.vue?vue&type=script&setup=true&lang=ts"

import "./SuccessMessage.vue?vue&type=style&index=0&id=027b1bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027b1bbc"]])

export default __exports__